<template>
	<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="900px">
		<v-card height="800">
			<v-card-title>
				<span class="title font-weight-bold">服务目录</span>
				<v-spacer />
				<v-btn class="mx-0" icon @click="dialog = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-title class="pt-0">
				<v-btn-toggle v-model="queryParam.bizType" @change="searchQuery" tile color="primary" group dense>
					<v-btn v-for="item in bizTypeList" :key="item.bizName" :value="item.bizType" class="ma-0">{{ item.bizName }}</v-btn>
				</v-btn-toggle>
				<v-spacer />
				<v-text-field v-model="queryParam.condition" @click:append="searchQuery" @keyup.enter="searchQuery" class="vtk-field d-inline-block float-right" outlined placeholder="输入目录名称" append-icon="mdi-magnify" dense clearable hide-details></v-text-field>
			</v-card-title>
			<v-divider class="mx-6" />
			<v-card-text class="pb-0 pt-1">
				<v-data-table v-model="selectedProj" item-key="projCode" :headers="header" :items="pageData" :loading="loading" show-select disable-pagination loading-text="数据加载中..." class="elevation-0" hide-default-footer>
					<template v-slot:[`item.projName`]="{ item }">
						<div class="py-3 vtk-cursor-pointer body-1" :title="item.projName">
							<v-chip class="mr-1" :class="item.areaCode.length | dict('0:green lighten-5  green--text/2:blue lighten-5  blue--text/4:cyan lighten-5  cyan--text/6:orange lighten-5  orange--text')" small label>
								{{ item.areaCode.length | dict("0:国家/2:省级/4:市级/6:区县") }}
							</v-chip>
							<v-chip class="mr-1 blue--text orange lighten-5 orange--text" small label>
								{{ item.bizType | dict("1:教育/2:康复/3:就业/4:培训/5:保障/6:维权/7:文体/8:无碍/9:其他") }}
							</v-chip>
							{{ item.projName }}
						</div>
					</template>
					<template v-slot:no-data>
						<v-card class="px-6 pt-4 pb-4 mt-3" elevation="0" id="train">
							<v-img contain width="280" class="mx-auto mt-16" src="@/assets/img/noData.png" alt="" />
							<p class="grey--text mt-4">暂无数据</p>
						</v-card>
					</template>
				</v-data-table>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="dialog = false" elevation="0"><v-icon>mdi-progress-close</v-icon> 取消</v-btn>
				<v-btn @click="save" class="white--text mr-3" color="green" elevation="0"><v-icon>mdi-progress-check</v-icon> 确认</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Mixins from "@/compositions/mixins/minxs";
import Message from "../../components/message";
export default {
	name: "VtkProj",
	mixins: [Mixins],
	data: () => ({
		url: {
			list: "/app/abiz/list",
		},
		header: [{ text: "目录名称", value: "projName", sortable: false }],
		loading: false,
		pageData: [],
		queryParam: { bizType: "A" },
		//主题筛选
		bizType: "", //主题
		bizTypeList: [
			{ bizType: "A", bizName: "全部" },
			{ bizType: "1", bizName: "教育" },
			{ bizType: "2", bizName: "康复" },
			{ bizType: "3", bizName: "就业" },
			{ bizType: "4", bizName: "培训" },
			{ bizType: "5", bizName: "保障" },
			{ bizType: "6", bizName: "维权" },
			{ bizType: "7", bizName: "文体" },
			{ bizType: "8", bizName: "无碍" },
			{ bizType: "9", bizName: "其他" },
		],
		dialog: false,
		selectedProj: [], //服务目录多选
		projName: "",
		apps: {},
	}),
	mounted() {},
	methods: {
		async add(apps) {
			this.apps = apps;
			this.dialog = true;
			this.user = this.$vtk.storage.get("user");
			this.queryParam.leve = this.apps.leve;
			this.queryParam.type = this.apps.type;
			await this.loadPage();
			await apps.bizCode.split(",")?.forEach((e) => {
				this.selectedProj.push({ projCode: e });
			});
		},
		// 服务目录确认查询
		save() {
			if (this.selectedProj.filter((item) => ["S0", "T0"].includes(item.projCode)).length == 1) {
				Message.toast("目录服务、任务服务，当前两类服务不能单选只能多选！", { color: "error" });
			} else {
				this.dialog = false;
				let projCode = [];
				// let projName = [];
				this.selectedProj.forEach((e) => {
					projCode.push(e.projCode);
					// projName.push(e.projName);
				});
				this.$emit("toPage", projCode.join());
			}
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep {
	table tr th,
	table tr td {
		padding: 0 2px !important;
	}
}
</style>
